import { render, staticRenderFns } from "./RGB.vue?vue&type=template&id=abb67baa&"
import script from "./RGB.vue?vue&type=script&lang=ts&"
export * from "./RGB.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports